import {Component} from '@angular/core';

@Component({
  selector: 'app-success-lines-icon',
  templateUrl: './success-lines-icon.component.html'
})
export class SuccessLinesIconComponent {
}
